import { useMemo } from "react"
import { observer } from "mobx-react"
import { Col, Row, Typography } from "antd"

import { CurrencyIcon } from "@src/app/components/CurrencyIcon"
import { GlobalCurrenciesCollection } from "@src/app/CurrenciesCollection"
import { PaymentInfoType } from "@src/shared/componemts/RefundForm/classses/RefundEntity"

type Props = {
  payment: PaymentInfoType
}
export const RefundFormHeader = observer(({ payment }: Props) => {
  const currencies = GlobalCurrenciesCollection()
  const currency = useMemo(() => {
    return currencies.getBySymbolNetwork({
      network: payment.network,
      symbol: payment.symbol,
    })
  }, [payment])

  return (
    <Row align={"middle"} gutter={10} justify={"start"}>
      <Col>
        <CurrencyIcon network={payment.network} symbol={payment.symbol} />
      </Col>

      <Col>
        <Typography.Title level={4} style={{ margin: 0 }}>
          {payment.amount}
        </Typography.Title>
      </Col>

      <Col>
        <Typography.Paragraph style={{ margin: 0 }}>
          {`${currency?.symbol_alias ?? payment.symbol} (${payment.network})`}
        </Typography.Paragraph>
      </Col>
    </Row>
  )
})
